<div class="view-container">
  <mat-card>
    <mat-card-content>
      <!-- Title and primary action on top; filters beneath. -->
      <div class="toolbar">
        <div class="toolbar-row">
          <small class="text-muted toolbar-text">
            Products substituted for <strong>{{ selectedCompany?.name || 'the selected builder' }}</strong>.
          </small>
          <button mat-flat-button color="primary" class="toolbar-item" (click)="addProduct()">
            <mat-icon>add</mat-icon> Add product
          </button>
        </div>
        <div class="toolbar-row">
          <mat-form-field class="accent search-field">
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" placeholder="Product name or SKU">
            <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-checkbox class="toolbar-item" [(ngModel)]="showPast" (ngModelChange)="onShowPastChange()">
            Show past substitutions
          </mat-checkbox>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngFor="let card of cards; trackBy: trackCard" [id]="cardElementId(card.productId)">
    <mat-card-content>
      <div class="card-layout">
        <div class="original">
          <ng-container *ngIf="isProductLoaded(card.productId); else productPending">
            <ng-container *ngTemplateOutlet="productCell; context: { product: productOf(card.productId), compact: true }"></ng-container>
          </ng-container>
          <ng-template #productPending>
            <ng-container *ngTemplateOutlet="productNotLoaded; context: { id: card.productId }"></ng-container>
          </ng-template>
          <small *ngIf="card.ended" class="text-muted">No longer substituted</small>
          <button mat-stroked-button color="accent" class="dashed-button" (click)="addSubstitution(card.productId)">
            <mat-icon>add</mat-icon> Add substitution
          </button>
        </div>

        <div class="scopes">
          <div *ngFor="let scope of card.scopes; trackBy: trackScope" class="scope">
            <mat-chip-list [selectable]="false">
              <mat-chip *ngIf="scope.tagId; else allHomes" class="home-tag-chip">
                <span class="green-chip-label">{{ tagName(scope.tagId) }}</span>
              </mat-chip>
              <ng-template #allHomes><mat-chip>All homes</mat-chip></ng-template>
            </mat-chip-list>

            <div class="rail">
              <div *ngFor="let period of scope.periods; trackBy: trackPeriod" class="period">
                <div class="dot" [class.dot-now]="period.isNow && !period.faded" [class.dot-muted]="period.faded"></div>

                <div class="band" [class.band-editing]="period.edit" [class.band-disabled]="!period.edit && !period.enabled"
                  [class.band-now]="!period.edit && period.isNow">

                  <ng-container *ngIf="period.edit as edit; else viewBand">
                    <mat-form-field class="accent band-field">
                      <mat-label>From</mat-label>
                      <input matInput [(ngModel)]="edit.draftFrom" [matDatepicker]="fromPicker" placeholder="Choose a date">
                      <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                      <mat-datepicker #fromPicker>
                        <mat-datepicker-actions>
                          <button mat-button matDatepickerCancel>Cancel</button>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <button *ngIf="edit.draftFrom" matSuffix mat-icon-button type="button" aria-label="Clear"
                        (click)="clearDraftFrom(edit)">
                        <mat-icon>close</mat-icon>
                      </button>
                      <mat-hint>{{ edit.draftFrom ? (edit.draftFrom | date:'mediumDate') : 'No start' }}</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="accent band-field">
                      <mat-label>To (inclusive)</mat-label>
                      <input matInput [(ngModel)]="edit.draftTo" [matDatepicker]="toPicker" placeholder="Choose a date">
                      <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                      <mat-datepicker #toPicker>
                        <mat-datepicker-actions>
                          <button mat-button matDatepickerCancel>Cancel</button>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <button *ngIf="edit.draftTo" matSuffix mat-icon-button type="button" aria-label="Clear"
                        (click)="clearDraftTo(edit)">
                        <mat-icon>close</mat-icon>
                      </button>
                      <mat-hint>{{ edit.draftTo ? (edit.draftTo | date:'mediumDate') : 'No end' }}</mat-hint>
                    </mat-form-field>

                    <mat-form-field class="accent band-field">
                      <mat-label>Home tag</mat-label>
                      <mat-select [(ngModel)]="edit.draftTagId">
                        <mat-option [value]="null">None (all homes)</mat-option>
                        <mat-option *ngIf="edit.draftTagId && !isHomeTag(edit.draftTagId)" [value]="edit.draftTagId">
                          {{ tagName(edit.draftTagId) }}
                        </mat-option>
                        <mat-optgroup *ngFor="let group of tagGroups; trackBy: trackTagGroup" [label]="group.name">
                          <mat-option *ngFor="let tag of group.tags; trackBy: trackTag" [value]="tag.id">{{ tag.name }}</mat-option>
                        </mat-optgroup>
                      </mat-select>
                    </mat-form-field>

                    <button mat-flat-button color="primary" type="button" (click)="done(edit)">Done</button>
                  </ng-container>

                  <ng-template #viewBand>
                    <span class="when">{{ period.when }}</span>
                    <small *ngIf="period.whenDetail" class="text-muted">{{ period.whenDetail }}</small>
                    <mat-chip-list *ngIf="period.isNow || period.isPast" [selectable]="false">
                      <mat-chip *ngIf="period.isNow" class="green-chip">Now</mat-chip>
                      <mat-chip *ngIf="period.isPast">Ended</mat-chip>
                    </mat-chip-list>
                    <small *ngIf="period.collapsed" class="text-muted">{{ period.summary }}</small>
                    <button mat-icon-button color="accent" matTooltip="Edit dates and tag" aria-label="Edit dates and tag"
                      (click)="startEdit(period)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </ng-template>

                  <span class="band-spacer"></span>
                  <mat-slide-toggle [checked]="period.enabled"
                    (change)="setEnabled(period, $event.checked)">
                    {{ period.enabled ? 'Enabled' : 'Disabled' }}
                  </mat-slide-toggle>
                </div>

                <ng-container *ngIf="!period.collapsed">
                  <div [class.faded]="period.faded">
                    <div *ngFor="let row of period.rows; trackBy: trackRow" class="row">
                      <mat-chip-list [selectable]="false" class="status-chip-list">
                        <mat-chip class="status-chip" [ngClass]="statusChipClass(rowStatus(period, row))"
                          [matTooltip]="statusTips[rowStatus(period, row)]">
                          {{ rowStatus(period, row) }}
                        </mat-chip>
                      </mat-chip-list>
                      <div class="row-product">
                        <ng-container *ngIf="isProductLoaded(row.toProductId); else rowProductPending">
                          <ng-container *ngTemplateOutlet="productCell; context: { product: productOf(row.toProductId) }"></ng-container>
                        </ng-container>
                        <ng-template #rowProductPending>
                          <ng-container *ngTemplateOutlet="productNotLoaded; context: { id: row.toProductId }"></ng-container>
                        </ng-template>
                      </div>
                      <button mat-icon-button color="accent" matTooltip="Remove from period" aria-label="Remove from period" (click)="removeRow(period, row)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <button mat-button color="primary" class="add-to-period"
                    (click)="addToPeriod(period)">
                    <mat-icon>add</mat-icon> Add product to this period
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="loaded && cards.length === 0">
    <mat-card-content>
      <p class="text-muted m-0">
        {{ searchTerm ? 'No substitutions match the search.' : 'No current product substitutions for this builder.' }}
      </p>
    </mat-card-content>
  </mat-card>
</div>

<!-- Product display, matching the theme editor's line items. Compact stacks the details for narrow columns. -->
<ng-template #productCell let-product="product" let-compact="compact">
  <!-- Compact: type and status on top, then the thumbnail beside a stacked logo, name and SKU. -->
  <div *ngIf="compact; else lineItemProduct" class="product" fxLayout="column" fxLayoutGap="8px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="line-item-details">
      <small *ngIf="productTypeName(product)" class="text-info">{{ productTypeName(product) }}</small>
      <ng-container *ngTemplateOutlet="productStatus; context: { product: product }"></ng-container>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="productThumbnail; context: { product: product }"></ng-container>
      <div class="product-details" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px">
        <img class="company-logo" *ngIf="companyLogo(product)" [src]="companyLogo(product)">
        <span class="product-company-name" *ngIf="!companyLogo(product) && companyName(product)">{{ companyName(product) }}</span>
        <span>{{ product.name || product.id }}</span>
        <small *ngIf="product.sku" class="text-muted">{{ product.sku }}</small>
      </div>
    </div>
  </div>

  <ng-template #lineItemProduct>
    <div class="product" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="productThumbnail; context: { product: product }"></ng-container>
      <div class="product-details" fxLayout="column" fxLayoutAlign="center start">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="line-item-details">
          <small *ngIf="productTypeName(product)" class="text-info">{{ productTypeName(product) }}</small>
          <ng-container *ngTemplateOutlet="productStatus; context: { product: product }"></ng-container>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="line-item-details">
          <img class="company-logo" *ngIf="companyLogo(product)" [src]="companyLogo(product)">
          <span class="product-company-name" *ngIf="!companyLogo(product) && companyName(product)">{{ companyName(product) }}</span>
          <span>{{ product.name || product.id }}</span>
          <small *ngIf="product.sku">{{ product.sku }}</small>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>

<!-- Nothing while a product's details load; afterwards, the theme editor's message if it is missing. -->
<ng-template #productNotLoaded let-id="id">
  <div *ngIf="!isProductLoading(id)" class="product">
    <i>Could not load Product</i>
  </div>
</ng-template>

<ng-template #productThumbnail let-product="product">
  <div class="thumbnail-container">
    <ng-container *ngIf="product.previewArtifactId; else showNoImageIcon">
      <img src="/assets/images/no-image-icon.svg" lazyLoad="{{situViewUrl}}/home/getimage?artifactid={{product.previewArtifactId}}&filename=thumbnail.webp" class="thumbnail">
      <mat-icon class="view-3d-button link" (click)="onView3dPreview(product); $event.stopPropagation();" color="accent">view_in_ar</mat-icon>
    </ng-container>
    <ng-template #showNoImageIcon>
      <img src="/assets/images/no-image-icon.svg" class="thumbnail">
    </ng-template>
  </div>
</ng-template>

<!-- Product status, matching the theme editor's line items. -->
<ng-template #productStatus let-product="product">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <div *ngIf="product.disabled; else checkNotLive" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <mat-icon class="text-warning">disabled_by_default</mat-icon>
      <small class="text-warning">Product Is Disabled</small>
    </div>

    <ng-template #checkNotLive>
      <div *ngIf="isNotLive(product); else checkCallouts" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <product-workflow-icon [workflowStateType]="product.workflowState"></product-workflow-icon>
        <small class="text-info">Product Is Not Live</small>
      </div>
    </ng-template>

    <ng-template #checkCallouts>
      <div *ngIf="product.calloutsEnabled === false" matTooltip="Product Callouts Are Turned Off">
        <mat-icon class="text-blue">preview_off</mat-icon>
      </div>
    </ng-template>
  </div>
</ng-template>
